/**
 * Constants definition.
 *
 * @type {{RESIDENTIAL: string, ESTATE_BIG_CLIENT: string}}
 */
const CLIENT_TYPE = {
  RESIDENTIAL: 'RESIDENTIAL',
  ESTATE_BIG_CLIENT: 'ESTATE_BIG_CLIENT',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const CLIENT_TYPE_ENUM = Object.keys(CLIENT_TYPE);

const RESIDENTIAL = CLIENT_TYPE_ENUM[0];
const ESTATE_BIG_CLIENT = CLIENT_TYPE_ENUM[1];

export {
  CLIENT_TYPE,
  CLIENT_TYPE_ENUM,
  RESIDENTIAL,
  ESTATE_BIG_CLIENT,
};
